import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template", "subtotal"]

  add(event) {
    event.preventDefault()
    const index = new Date().getTime()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, index)
    this.containerTarget.insertAdjacentHTML("beforeend", content)
    this.recalculate()
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("[data-line-item-row]")
    const destroyField = row.querySelector("input[name*='_destroy']")
    if (destroyField) {
      destroyField.value = "1"
      row.style.display = "none"
    } else {
      row.remove()
    }
    this.recalculate()
  }

  recalculate() {
    let subtotal = 0
    const rows = this.containerTarget.querySelectorAll("[data-line-item-row]")
    rows.forEach(row => {
      if (row.style.display === "none") return
      const qty = parseFloat(row.querySelector("[data-field='quantity']")?.value) || 0
      const price = parseFloat(row.querySelector("[data-field='unit_price']")?.value) || 0
      const lineTotal = qty * price
      const totalEl = row.querySelector("[data-field='total']")
      if (totalEl) totalEl.textContent = "$" + lineTotal.toFixed(2)
      subtotal += lineTotal
    })
    if (this.hasSubtotalTarget) {
      this.subtotalTarget.textContent = "$" + subtotal.toFixed(2)
    }
  }
}
